import { useEffect, useRef, useState } from 'react';

/**
 * 1.Provide runFunction args type when calling hook
 *
 * > ... useFunctionThrottling<[boolean, string]>
 *
 * > runFunction(true, "example")
 *
 * 2.Provide callback as first argument and minimum delay as second argument (ms)
 *
 * > ... useFunctionThrottling<T>(() => {}, 8000)
 */
export default function useFunctionThrottling<T>(
  fn: (args: T) => any,
  delay: number
): (args: T) => any {
  const lastCall = useRef<Date>(new Date(new Date().getTime() - (delay + 1)));
  const runFunction: (args: T) => void = (args) => {
    if (new Date().getTime() - lastCall.current.getTime() > delay) {
      fn(args);
      lastCall.current = new Date();
    }
  };
  return runFunction;
}
